import {cssTheme} from '../../../'
import {css} from '../../../theme/css'
import {spacing} from '../../../theme/theme'

export const classes = {
  container: css`
    margin-inline: ${spacing(1.5)};
  `,
  zoomControl: css`
    border-radius: 100%;

    & > button:first-child {
      border-end-start-radius: 0;
      border-end-end-radius: 0;

      border-block-end: 1px solid ${cssTheme.default.day.line};
    }

    & > button:last-child {
      border-start-start-radius: 0;
      border-start-end-radius: 0;
    }
  `,
}
